import codiciComuniJSON from "./codici_comuni.json";
import monthMapJSON from "./month_map.json";

export const generateFiscalCode = (
  cognome,
  nome,
  anno_nascita,
  mese_nascita,
  giorno_nascita,
  sesso,
  luogo_nascita
) => {
  let consonanti_cognome = cognome.match(/[^aeiou]/gi).join("");
  let consonanti_nome = nome.match(/[^aeiou]/gi).join("");
  let vocali_cognome = cognome.match(/[aeiou]/gi).join("");

  // ultime 2 cifre dell'anno di nascita
  let anno_nascita_ref = anno_nascita.slice(-2);
  let month_map = monthMapJSON;

  let giorno_nascita_ref =
    sesso === "M" ? giorno_nascita : (Number(giorno_nascita) + 40).toString();
  let mese_nascita_ref = month_map[mese_nascita];
  let luogo_nascita_ref = codiciComuniJSON[luogo_nascita.replace(" ", "_")];

  // estraggo dal cognome la 1,2,3 consonante
  if (consonanti_cognome.length >= 3) {
    consonanti_cognome = consonanti_cognome.substring(0, 3);
  } else {
    let cognome_senza_consonanti = cognome.replace(consonanti_cognome, "");
    let vocali_da_estrarre = 3 - consonanti_cognome.length;
    let cognome_vocali_ref = cognome_senza_consonanti.slice(
      0,
      vocali_da_estrarre
    );
    consonanti_cognome = consonanti_cognome + cognome_vocali_ref;
  }

  // estraggo dal nome la 1,3,4 consonante
  if (consonanti_nome.length >= 4) {
    let consonante_nome_prima = consonanti_nome.charAt(0);
    let consonante_nome_terza = consonanti_nome.charAt(2);
    let consonante_nome_quarta = consonanti_nome.charAt(3);
    consonanti_nome =
      consonante_nome_prima + consonante_nome_terza + consonante_nome_quarta;
  }

  let codice_fiscale_generato = (
    consonanti_cognome +
    consonanti_nome +
    anno_nascita_ref +
    mese_nascita_ref +
    giorno_nascita_ref +
    luogo_nascita_ref
  ).toUpperCase();

  var set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ",
    setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX",
    s = 0;

  let cf = codice_fiscale_generato.toUpperCase();

  for (let i = 1; i <= 13; i += 2) {
    s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }

  for (let i = 0; i <= 14; i += 2) {
    s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
  }

  let codice_fiscale_generato_completo =
    codice_fiscale_generato + setpari[s % 26];

  return codice_fiscale_generato_completo.toUpperCase();
};
